import React from 'react';
import styled from 'styled-components';
import {
  incidentTypeConfig,
  IncidentTypeKey,
} from '../../pages/Incidents/utils/constants';
import { IconName, SvgIcon } from '../Icon';
import { theme } from '../../styles/theme';

interface IIncidentType {
  name: string;
  disabled?: boolean;
}

const Label = styled.div`
  margin-left: 8px;
  font-size: 12px;
  font-weight: 500;
`;

interface IEventTypeUI {
  label: string;
  icon: IconName;
  $color: string;
  className?: string;
  $disabled?: boolean;
}

export const ALL_INCIDENTS_OPTION_VALUE = 'incidents';
export const ALL_INCIDENTS_OPTION_NAME = 'All Incidents';

const IncidentTypeUI = styled(({ label, icon, className }: IEventTypeUI) => (
  <div className={className}>
    <SvgIcon name={icon} width={16} height={16} customFill="currentColor" />
    <Label>{label}</Label>
  </div>
))`
  display: flex;
  align-items: center;
  color: ${({ $color, $disabled }) =>
    $disabled ? theme.colors.secondary800 : $color};
`;

export const IncidentType = ({ name, disabled }: IIncidentType) => {
  if (name === ALL_INCIDENTS_OPTION_NAME) {
    return (
      <IncidentTypeUI
        icon="incidents"
        label={ALL_INCIDENTS_OPTION_NAME}
        $color={theme.colors.mainBlue}
        $disabled={disabled}
      />
    );
  }

  const { icon, color } = incidentTypeConfig[name as IncidentTypeKey];

  return (
    <IncidentTypeUI
      icon={icon}
      label={name}
      $color={color}
      $disabled={disabled}
    />
  );
};
